<kt-portlet>
    <!--   <kt-portlet-header title="Test Alani"></kt-portlet-header> -->
    <kt-portlet-body>

        <div class="kt-section">
            <div class="kt-section__content">

                <div class="row justify-content-lg-center">

                    <div kt-menu-card [menuButtonTitle]="'Göster'" [menuTitle]="'Hareket Raporu'"
                        [menuSubTitle]="'Hangi POP hangi tarihte hangi noktaya teslim edildi...'"
                        (onButtonClick)="gotoReport1($event)">
                    </div>

                    <div kt-menu-card [menuButtonTitle]="'Göster'" [menuTitle]="'SKT Raporu'"
                        [menuSubTitle]="'Son kullanım tarihi yaklaşan ürünler...'"
                        (onButtonClick)="gotoReport2($event)">
                    </div>

                </div>

            </div>
        </div>

<div id="divLoading" #divLoading>Buraya bi loading</div>

<div  [whatIsThisTooltip]='"Selam nasilsin bakalim"'>Hasan Selam</div>

    </kt-portlet-body>
</kt-portlet>



<!-- Modal template 1 -->
<ng-template #content3 let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Modal title</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>One fine body&hellip;</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
    </div>
</ng-template>